const article = {
    slug: "first_noir_kei_ninomiya_experience",
    category: "BRAND ENTRY",
    title: "初めてのNOIR KEI NINOMIYA｜ノワールケイニノミヤをレンタル体験",
    listDescription:
      "黒、チュール、ハーネス、構築的な造形。NOIR KEI NINOMIYAを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのNOIR KEI NINOMIYAをレンタル体験｜ノワールケイニノミヤを着て知るEnclopedia",
      description:
        "NOIR KEI NINOMIYAが気になるけれど、どんなブランドか分からない方へ。ノワールケイニノミヤの魅力、チュール、ハーネス、フリル、レーザーカット、構築的ドレスの見方を分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのNOIR KEI NINOMIYA,NOIR KEI NINOMIYA 初めて,ノワールケイニノミヤ 初めて,NOIR KEI NINOMIYA とは,ノワールケイニノミヤ どんなブランド,NOIR KEI NINOMIYA レンタル,ノワールケイニノミヤ レンタル,NOIR KEI NINOMIYA アーカイブ,ノワールケイニノミヤ アーカイブ,NOIR KEI NINOMIYA チュール,ノワールケイニノミヤ ハーネス,ノワールケイニノミヤ フリル,ノワールケイニノミヤ ドレス,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_noir_kei_ninomiya_experience",
    },
    hero: {
      label: "FIRST NOIR KEI NINOMIYA EXPERIENCE",
      number: "06 / ENTRY",
      titleLines: ["初めての", "NOIR KEI NINOMIYAをレンタル体験。"],
      body:
        "NOIR KEI NINOMIYAは、\n黒を静かな色としてではなく、構造を浮かび上がらせるための色として扱うブランドです。\nチュール、ハーネス、フリル、パーツの接続。\n初めて知るなら、まずは“着ることで分かる黒の立体感”から入るのが自然です。",
      keywords: [
        "first experience",
        "black construction",
        "tulle",
        "noir kei ninomiya",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["黒をまとうのではなく、", "黒の構造を着る。"],
      image: "media/archive_fashion/archive_guide6.png",
      imageAlt:
        "初めてのNOIR KEI NINOMIYAをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるNOIR KEI NINOMIYAを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/NOIR%20KEI%20NINOMIYA（ノワールケイニノミヤ）/?number=50",
    },
    thesis: {
      text:
        "NOIR KEI NINOMIYAは、黒を装飾ではなく、素材・接続・造形によって立ち上げるブランドです。",
      keywords: ["black", "construction", "experience"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "NOIR KEI NINOMIYAが気になる。",
          "でも、どこから見ればいいか分からない。",
        ],
        body:
          "NOIR KEI NINOMIYAは、写真では“黒くて装飾的な服”に見えることがあります。\nしかし実際には、チュールやフリルの繊細さ、ハーネスやパーツ接続の硬さ、身体から浮き上がるような立体構造が同時に存在しています。\nこのページでは、ノワールケイニノミヤを“可愛い黒”ではなく、“黒を構築するブランド”として理解する入口を作ります。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "黒をシンプルに見せるのではなく、",
          "黒で構造を浮かび上がらせる。",
        ],
        body:
          "NOIR KEI NINOMIYAは、コムデギャルソンの中でも、黒を軸に独自の造形を追求するブランドです。\nチュール、オーガンジー、フリル、ハーネス、スタッズ、リング、レーザーカット的な表現など、素材やパーツを組み合わせながら、服そのものを立体的な構造体として成立させます。\nそのため、ノワールケイニノミヤの魅力は、色や装飾だけではなく、“どう接続され、どう身体から立ち上がるか”にあります。",
        knowledgeItems: [
          {
            title: "チュールは、甘さではなく立体感を作る素材。",
            text:
              "NOIR KEI NINOMIYAのチュールは、柔らかい装飾だけではありません。硬さ、張り、重なりによって、黒の中に陰影と奥行きを生みます。",
          },
          {
            title: "ハーネスは、服と身体の距離を変える。",
            text:
              "身体に沿うだけではなく、身体の上にもう一つの構造を作る。ハーネスやパーツ接続は、服を立体的に見せる重要な要素です。",
          },
          {
            title: "装飾が、服の骨格になる。",
            text:
              "フリルやパーツは表面の飾りではなく、服の輪郭やボリュームを作る骨格として機能します。",
          },
          {
            title: "アーカイブで見ると、黒の表現の幅が分かる。",
            text:
              "同じ黒でも、シーズンや素材によって強さ、繊細さ、身体との距離が変わります。過去作を見ることで、その変化が分かります。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE NOIR?",
        titleLines: [
          "NOIR KEI NINOMIYAを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "BLACK",
            text:
              "黒を単色としてではなく、素材の厚み、透け、影、光の差で変化するものとして見る視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "TULLE & FRILL",
            text:
              "チュールやフリルは甘さだけでなく、立体感と陰影を作る構造として機能します。",
          },
          {
            tag: "ENTRY 03",
            title: "HARNESS & PARTS",
            text:
              "ハーネス、スタッズ、リング、パーツ接続によって、身体の上にもう一つの骨格を作ります。",
          },
          {
            tag: "ENTRY 04",
            title: "SCULPTURAL FORM",
            text:
              "服を平面ではなく、身体から浮き上がる造形として見ると、NOIR KEI NINOMIYAの面白さが分かりやすくなります。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "NOIR KEI NINOMIYAは、写真で見るよりも、実際に身体に乗せたときの奥行きや緊張感で理解が進むブランドです。",
        items: [
          {
            index: "01",
            title: "黒なのに、重く見えない理由",
            text:
              "透ける素材、重なり、空気を含むチュールによって、黒の中に軽さと陰影が生まれます。",
          },
          {
            index: "02",
            title: "装飾ではなく、構造として立ち上がる",
            text:
              "フリルやハーネスは表面の飾りではなく、服の輪郭を作る要素です。着ると身体との距離が見えてきます。",
          },
          {
            index: "03",
            title: "繊細さと強さが同時にある",
            text:
              "チュールの軽さと、パーツ接続の硬さ。相反する要素が同時にあることで、NOIR KEI NINOMIYAらしい緊張感が生まれます。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "黒を着るのではなく、",
          "黒の構造を体験する。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのNOIR KEI NINOMIYAほど、",
          "レンタルで理解が深まる。",
        ],
        items: [
          {
            number: "01",
            title: "写真では、素材の奥行きが読み切れない",
            text:
              "チュール、オーガンジー、フリル、パーツ接続は、平面写真では質感や空気感が伝わりにくい要素です。",
          },
          {
            number: "02",
            title: "身体との距離を確かめられる",
            text:
              "ハーネスや立体的なボリュームは、身体からどのように浮き上がるかで印象が変わります。実際に着る意味があります。",
          },
          {
            number: "03",
            title: "強いデザインを日常に入れられるか分かる",
            text:
              "視覚的には強く見えても、実際に着るとスタイリングに馴染むことがあります。レンタルはその距離を測る手段になります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるNOIR KEI NINOMIYA。"],
        body:
          "実在庫への導線は、“NOIR KEI NINOMIYAを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "NOIR KEI NINOMIYA / 2025SS Dark Rose",
            title: "デザインテーラードジャケット",
            text:
              "“ダークローズ”をテーマに、黒と赤、チュールやベルトの緊張感を重ねた2025SS。テーラードの輪郭にノワールらしい構築性を宿した一着。",
            href:
              "https://www.enclopedia-official.com/product/30dc8d80-a884-4515-b7fd-fa6a19c1e457",
            image:
              "media/product/1772806139.085684530dc8d80-a884-4515-b7fd-fa6a19c1e457.jpg",
          },
          {
            meta: "NOIR KEI NINOMIYA / 2023AW Noir in bloom",
            title: "サスペンダーボリュームスカート",
            text:
              "“Noir in bloom”の解放感を背景に、サスペンダーの硬さとボリュームのある造形を組み合わせた、花が咲くような立体感を持つスカート。",
            href:
              "https://www.enclopedia-official.com/product/b56062ca-e8ab-4f0e-a985-c8e74dd22cab",
            image:
              "media/product/1762346110.0680037b56062ca-e8ab-4f0e-a985-c8e74dd22cab.jpg",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "NOIR KEI NINOMIYAは、どんなブランドですか？",
            answer:
              "黒を軸に、チュール、ハーネス、フリル、パーツ接続などを用いて、服を立体的な構造として見せるブランドです。",
          },
          {
            question: "ノワールケイニノミヤは、コムデギャルソンのブランドですか？",
            answer:
              "はい。コムデギャルソンの中で展開されるブランドの一つで、二宮啓による黒を軸にした構築的な表現が特徴です。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "ジャケット、チュールトップス、スカート、ハーネス系アイテムなど、黒の構造や素材の重なりが分かりやすいものがおすすめです。",
          },
          {
            question: "写真と実物で印象は変わりますか？",
            answer:
              "大きく変わります。特にチュールやフリルの奥行き、ハーネスの立体感、黒の陰影は実物で理解しやすい要素です。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのNOIR KEI NINOMIYAを、",
          "レンタルから始める。",
        ],
        body:
          "黒、チュール、ハーネス、構築的な造形。\nEnclopediaで、NOIR KEI NINOMIYAのアーカイブを体験してください。",
        buttonLabel: "レンタルできるNOIR KEI NINOMIYAを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/NOIR%20KEI%20NINOMIYA（ノワールケイニノミヤ）/?number=50",
      },
    },
  };

export default article;
